/**
 * DashboardOverviewTab.jsx — Phase 147 (Dashboard Cleanup), extracted from
 * Dashboard.jsx unchanged. The Task Hub list — the primary Overview
 * landing content, driven by the sticky header's filters/metrics above
 * (see DashboardStickyHeader.jsx).
 */
import React from "react";
import TaskHubWidget from "@/components/TaskHubWidget";
import TabSection from "@/components/dashboard/TabSection";
import { ReviewNudge } from "@/components/ReviewNudge";
import { LeaveBalanceCard } from "@/components/LeaveBalanceCard";

export default function DashboardOverviewTab({
  activeTab, taskStatusFilter, setTaskStatusFilter,
  taskPersonId, taskProjectId, taskBusinessUnit, socialTabSignal, balance,
}) {
  return (
    <TabSection activeTab={activeTab} id="overview">
      <ReviewNudge />
      <LeaveBalanceCard balance={balance} />
      {/* Phase 116 — Task-first landing: the Metric Grid remains the
          primary interactive filter, driving the Task Hub list below. */}
      <div className="mb-4" data-testid="home-task-hub-focus-zone">
        <TaskHubWidget
          statusFilter={taskStatusFilter}
          onStatusFilterChange={setTaskStatusFilter}
          personId={taskPersonId}
          projectId={taskProjectId}
          businessUnit={taskBusinessUnit}
          switchToSocialSignal={socialTabSignal}
        />
      </div>
    </TabSection>
  );
}
